/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Contact_InfoInputs */



/**
* | output |
* | --- |
* | "Contact Information" |
*
* @param {Profile_Contact_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_contact_info = /** @type {((inputs?: Profile_Contact_InfoInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Contact_InfoInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Informations de contact")
	if (locale === "es") return /** @type {LocalizedString} */ ("Información de contacto")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Informações de Contato")
	if (locale === "it") return /** @type {LocalizedString} */ ("Informazioni di Contatto")
	return /** @type {LocalizedString} */ ("Contact Information")
});